import { baseUrl } from "util/APIBaseUrl";
import { makeRequest } from "util/APIHelper";

export default async function uploadPayrollCSV(body) {
  const options = {
    path: `${baseUrl}/employees/upload-payslip`,
    method: "POST",
    body,
  };
  const payload = await makeRequest(options, true);
  return payload;
}
